import { createRouter, createWebHistory } from "vue-router"
import Home from "../views/Home.vue"
import InnerPage from "../views/InnerPage.vue"
// import Login from "../views/Login.vue"
import Watch from "../views/Watch.vue"
import Profile from "../views/Profile.vue"
import SearchPage from "../views/SearchPage.vue"
import CategoryPage from "../views/CategoryPage.vue"
import Callback from "../components/Callback.vue"
import AddUserProfile from "../views/AddUserProfile.vue"
// import EditUserProfile from "../views/EditUserProfile.vue"
import LoginTizen from "../views/LoginTizen.vue"
import DeviceManagement from "../views/DeviceManagement.vue"
import { isLoggedIn, refreshTokenIfNeeded } from "../composables/useAuth"
import { useLogin } from "../composables/useLogin"
import { useUserStore } from "../stores/user"
import { useDeviceManager } from "../stores/deviceManager"
import BasicPage from "../views/BasicPage.vue"
import SupportPage from "../views/SupportPage.vue"
import { computed } from "vue"

const routes = [
	{ path: "/", component: Home, name: "Root" },
	{ path: "/index.html", component: Home, name: "RootTV" },
	{ path: "/home", component: Home, name: "Home" },
	{ path: "/login", component: LoginTizen, name: "LoginTizen" },
	{ path: "/watch/:type/:id", name: "Watch", component: Watch, props: true },
	{ path: "/callback", name: "callback", component: Callback },
	{ path: "/add-profile", name: "AddUserProfile", component: AddUserProfile },
	{ path: "/search", name: "SearchPage", component: SearchPage },
	{ path: "/category/:tid", name: "CategoryPage", component: CategoryPage },
	{ path: "/category/movies/:tid", name: "CategoryMovies", component: CategoryPage },
	{ path: "/category/series/:tid", name: "CategorySeries", component: CategoryPage },
	{ path: "/profile", name: "Profile", component: Profile },
	{ path: "/devices", name: "DeviceManagement", component: DeviceManagement },
	{ path: "/movies", name: "MoviesPage", component: Home },
	{ path: "/series", name: "SeriesPage", component: Home },
	{ path: "/movie/:id", name: "InnerMovie", component: InnerPage },
	{ path: "/series/:id", name: "InnerSeries", component: InnerPage },
	{ path: "/error", name: "ErrorPage", props: true, component: () => import("../components/ErrorPage.vue") },
	{ path: "/contact", name: "ContactPage", component: () => import("../views/ContactPage.vue") },
	{ path: "/subscribe", name: "PromoPage", component: () => import("../views/PromoPage.vue") },
	{ path: "/mobile-login", name: "MobileLogin", component: () => import("../views/MobileLogin.vue") },
	{ path: "/auth-check", name: "AuthCheck", component: () => import("../views/AuthCheck.vue") },
	{ path: "/privacy-policy", name: "PrivacyPolicy", component: () => import("../views/BasicPage.vue") },
	{ path: "/terms-of-use", name: "TermsPage", component: () => import("../views/BasicPage.vue") },
	{
		path: "/:pathMatch(.*)*",
		name: "NotFound",
		component: () => import("../views/NotFound.vue"),
	},
	{ path: "/support", name: "SupportPage", component: SupportPage },
]

const router = createRouter({
	history: createWebHistory(import.meta.env.BASE_URL),
	routes,
	scrollBehavior() {
		return { top: 0 }
	},
})

router.beforeEach(async (to, from, next) => {
	const { login } = useLogin()
	const deviceManager = useDeviceManager()
	// console.log("Navigating to:", to.fullPath)
	// if (to.fullPath === "/index.html") {
	// 	next({ name: "Home", replace: true })
	// 	return
	// }

	// Protected routes that require both authentication and device registration
	const premiumRoutes = [
		"Watch",
		"InnerMovie",
		"InnerSeries",
		"Profile",
		"ContactPage",
		"SearchPage",
		"CategoryPage",
		"MoviesPage",
		"SeriesPage",
	]

	const isLoggedInFlag = isLoggedIn()
	const isFileProtocol = window.location.protocol === "file:"

	if (!isLoggedInFlag) {
		if (isFileProtocol) {
			// console.log("File protocol detected, skipping login", to.fullPath)
			next()
		} else if (
			to.name !== "Root" &&
			to.name !== "RootTV" &&
			to.name !== "Home" &&
			to.name !== "LoginTizen" &&
			to.name !== "PromoPage" &&
			to.name !== "MobileLogin" &&
			to.name !== "AuthCheck" &&
			to.name !== "callback" &&
			to.name !== "PrivacyPolicy" &&
			to.name !== "TermsPage" &&
			to.name !== "SupportPage"
		) {
			next({ name: deviceManager.deviceInfo.platform === "web" ? "PromoPage" : "MobileLogin" })
		}
	}

	if (premiumRoutes.includes(to.name)) {
		if (isLoggedInFlag) {
			const userStore = useUserStore()
			const hasActiveSubscription = await userStore.getUserSubscriptionStatus()

			if (hasActiveSubscription) {
				// Check if the current device is registered
				await deviceManager.listDevices()
				const isDeviceRegistered = await deviceManager.isCurrentDeviceRegistered()
				if (isDeviceRegistered) {
					next()
				} else {
					// Device not registered - redirect to device management page
					next({ name: "DeviceManagement", query: { error: "device_limit" } })
				}
			} else {
				next({ name: deviceManager.deviceInfo.platform === "web" ? "PromoPage" : "MobileLogin" })
			}
		} else {
			if (localStorage.getItem("refresh_token")) {
				const userStore = useUserStore()
				const hasActiveSubscription = await userStore.getUserSubscriptionStatus()
				if (hasActiveSubscription) {
					// Check if the current device is registered
					await deviceManager.listDevices()
					const isDeviceRegistered = await deviceManager.isCurrentDeviceRegistered()

					if (isDeviceRegistered) {
						next()
					} else {
						// Device not registered - redirect to device management page
						next({ name: "DeviceManagement", query: { error: "device_limit" } })
					}
				} else {
					next({ name: deviceManager.deviceInfo.platform === "web" ? "PromoPage" : "MobileLogin" })
				}
			} else {
				next({ name: deviceManager.deviceInfo.platform === "web" ? "PromoPage" : "MobileLogin" })
			}
			// sessionStorage.setItem("post_auth_redirect", to.fullPath)
			// login(to.fullPath)
			// return
		}
	} else {
		// Allow access to non-premium routes (Home, Search, etc.)
		next()
	}
})

export default router
